var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacialCraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 244,
    viewBox: "0 0 276 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_7408)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.833 35.3C132.017 34.8295 132.224 34.3556 132.121 33.8521C131.979 33.1063 131.222 32.6171 130.534 32.2752C124.653 29.3633 117.959 28.7859 111.447 28.4959C98.6274 27.9282 85.4091 28.3965 73.7822 33.5044C72.8953 33.8952 71.1444 35.4532 71.1097 37.4935L71.0928 40.2092C71.0811 42.6753 73.2873 44.6615 75.7445 44.3355C77.9464 44.039 80.2433 44.123 82.4824 44.3406C88.9979 45.0032 95.5463 46.8586 100.91 50.7013C104.397 53.2057 107.319 56.6259 109.049 60.5084C110.376 63.4948 110.334 69.0177 113.471 68.2097C115.653 67.6452 120.968 63.4247 121.509 63.3492C123.471 63.0348 125.465 63.1334 127.437 63.2355C130.183 63.3719 132.217 60.8303 131.478 58.1907C129.345 50.5294 128.602 43.2106 131.807 35.2814L131.833 35.3Z",
    fill: "#4545DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_68_7408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 28,
    width: 62,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.833 35.3C132.017 34.8295 132.224 34.3556 132.121 33.8521C131.979 33.1063 131.222 32.6171 130.534 32.2752C124.653 29.3633 117.959 28.7859 111.447 28.4959C98.6274 27.9282 85.4091 28.3965 73.7822 33.5044C72.8953 33.8952 71.1444 35.4532 71.1097 37.4935L71.0928 40.2092C71.0811 42.6753 73.2873 44.6615 75.7445 44.3355C77.9464 44.039 80.2433 44.123 82.4824 44.3406C88.9979 45.0032 95.5463 46.8586 100.91 50.7013C104.397 53.2057 107.319 56.6259 109.049 60.5084C110.376 63.4948 110.334 69.0177 113.471 68.2097C115.653 67.6452 120.968 63.4247 121.509 63.3492C123.471 63.0348 125.465 63.1334 127.437 63.2355C130.183 63.3719 132.217 60.8303 131.478 58.1907C129.345 50.5294 128.602 43.2106 131.807 35.2814L131.833 35.3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_68_7408)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4962 54.4879L79.891 56.2404L80.2324 58.2995L76.9734 57.7142L77.4962 54.4879Z",
    fill: "#4545DD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.695 62.5669C126.969 62.0778 118.244 62.3686 109.73 63.4167C108.872 61.0222 107.686 58.7028 106.225 56.4954C114.244 54.2717 122.411 51.9792 129.105 47.8995C132.658 45.7361 135.444 46.5443 134.87 50.2988C134.236 54.3794 134.359 58.463 135.717 62.5633L135.695 62.5669Z",
    fill: "#613C68"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.151 187.04C131.339 187.507 131.374 189.423 130.51 190.59C128.526 193.304 125.218 192.761 121.8 192.879C105.812 193.486 92.711 192.5 76.5237 188.833C74.2827 188.321 70.8701 186.494 70.5194 184.448C70.5194 184.448 70.3984 183.269 70.3824 182.888C70.1905 179.222 73.3505 176.229 77.0427 176.485C78.5852 176.588 80.1379 176.542 81.6707 176.444C88.1766 175.989 94.7157 174.33 100.005 170.656C105.294 166.982 109.232 161.084 109.542 154.625C109.463 156.107 119.17 158.417 120.427 158.645C124.298 159.381 128.269 158.552 131.966 159.124C128.935 168.562 127.107 177.254 131.151 187.04Z",
    fill: "#4545DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_68_7408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 154,
    width: 62,
    height: 40
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.151 187.04C131.339 187.507 131.374 189.423 130.51 190.59C128.526 193.304 125.218 192.761 121.8 192.879C105.812 193.486 92.711 192.5 76.5237 188.833C74.2827 188.321 70.8701 186.494 70.5194 184.448C70.5194 184.448 70.3984 183.269 70.3824 182.888C70.1905 179.222 73.3505 176.229 77.0427 176.485C78.5852 176.588 80.1379 176.542 81.6707 176.444C88.1766 175.989 94.7157 174.33 100.005 170.656C105.294 166.982 109.232 161.084 109.542 154.625C109.463 156.107 119.17 158.417 120.427 158.645C124.298 159.381 128.269 158.552 131.966 159.124C128.935 168.562 127.107 177.254 131.151 187.04Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_68_7408)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1047 160.744L97.4461 162.803L95.3892 163.088",
    fill: "#4545DD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.904 158.456C124.144 158.841 116.306 158.39 108.605 157.104C108.027 159.706 107.145 162.244 105.993 164.644C113.346 167.218 120.824 169.863 127.122 174.46C130.463 176.898 132.892 176.045 132.083 171.913C131.204 167.419 131.005 162.93 131.891 158.447L131.904 158.456Z",
    fill: "#613C68"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.799 154.574L108.17 66.7308C150.776 49.8863 188.17 66.0369 212.984 83.6837C232.784 97.7598 244.552 112.784 244.552 112.784C244.552 112.784 232.987 127.445 213.407 140.904C188.849 157.795 151.674 172.763 108.812 154.583L108.799 154.574Z",
    fill: "#50D7EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.487 110.664L108.194 72.1649L90.9596 76.9167L91.1921 110.384L91.4281 143.874L108.758 149.167L108.487 110.664Z",
    fill: "#8244B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_68_7408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 72,
    width: 19,
    height: 78
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.487 110.664L108.194 72.1649L90.9596 76.9167L91.1921 110.384L91.4281 143.874L108.758 149.167L108.487 110.664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_68_7408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.153 159.307L102.393 65.6679L124.251 60.9888L127.237 94.6366L106.648 160.481L100.153 159.307Z",
    fill: "#8B329E"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4431 111.718C71.4285 109.934 72.8758 108.527 74.6758 108.543L130.024 109.416C131.814 109.445 133.283 110.917 133.297 112.7C133.312 114.484 131.864 115.892 130.064 115.875L74.7071 115.015C72.9164 114.986 71.4485 113.514 71.4339 111.731L71.4431 111.718Z",
    fill: "#4545DD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.771 123.757C204.184 133.859 164.654 148.312 116.546 134.15C114.696 133.61 112.87 134.977 112.893 136.883L112.975 148.751C112.983 150.705 114.181 152.468 116.019 153.214C128.073 158.177 174.607 172.681 225.886 126.73C227.469 125.323 225.68 122.761 223.793 123.753L223.771 123.757Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.311 96.6413C218.653 96.2042 217.935 95.7428 217.152 95.7215C216.959 95.7184 216.739 95.7538 216.615 95.898C216.541 96.0003 216.514 96.1176 216.501 96.2441C216.415 96.7665 216.342 97.2982 216.524 97.8002C216.858 98.6849 217.894 99.0841 218.788 99.4383C222.11 100.771 224.973 102.98 228.154 104.561C228.546 104.747 229.578 105.474 229.964 105.13C230.331 104.811 229.892 104.045 229.657 103.778C228.481 102.44 226.383 101.409 224.92 100.388C223.063 99.1034 221.192 97.8659 219.308 96.6193L219.311 96.6413Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M207.369 85.466C205.288 83.5502 202.586 82.4912 199.933 81.526C180.183 74.247 159.231 69.2744 138.39 70.6367C137.942 70.6633 137.463 70.7062 137.111 70.9774C136.344 71.5525 136.622 72.8644 137.405 73.451C138.189 74.0375 139.21 74.1337 140.181 74.1929C160.17 75.4878 180.662 79.2117 197.783 89.9076C200.295 91.472 204.605 94.2401 207.693 92.773C210.794 91.3151 209.4 87.3448 207.347 85.4696L207.369 85.466Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 142.831C191.027 142.536 201.604 137.721 201.609 130.203C201.613 122.685 201.619 111.154 201.619 111.154C201.619 111.154 201.624 99.6236 201.629 92.1058C201.633 84.588 191.064 79.2964 181.528 78.5527C171.993 77.809 163.12 77.7392 163.112 86.9305C163.105 96.1217 163.109 110.251 163.109 110.251C163.109 110.251 163.1 124.371 163.105 133.571C163.11 142.772 171.982 143.113 181.518 142.806L181.5 142.831Z",
    fill: "#4545DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.322 87.0989C169.324 86.2622 169.458 85.619 169.663 85.4166C171.261 83.9623 178.722 84.5297 181.173 84.7247C188.703 85.3037 195.398 89.2721 195.391 91.9749L195.38 130.06C195.385 132.772 188.678 136.413 181.155 136.658C178.703 136.734 171.246 136.969 169.653 135.427C169.438 135.212 169.314 134.577 169.302 133.731L169.322 87.0989Z",
    fill: "#62C7CD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.35
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.392 130.069L195.392 129.289C188.394 125.686 172.991 115.065 169.324 90.1395L169.315 133.74C169.314 134.577 169.451 135.222 169.666 135.436C171.258 136.978 178.715 136.744 181.167 136.667C188.703 136.431 195.398 132.781 195.392 130.069Z",
    fill: "#D2BDFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_7408",
    x: -31,
    y: -27,
    width: 309.526,
    height: 305.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_7408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_7408",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacialCraft);
export default __webpack_public_path__ + "static/media/spacialCraft.16b28b077eaaa6b4aa618d0894e73d65.svg";
export { ForwardRef as ReactComponent };